import { useMutation } from "@tanstack/react-query";
import { updateLocation } from "@/api/queries/Locations";

export const useUpdateHomePhoto = () => {
  const mutation = useMutation({
    mutationFn: ({ id, photoUrl }: { id: string; photoUrl: string }) =>
      updateLocation(id, { homePhotoUrl: photoUrl }),
    // Remove onSuccess to prevent query invalidation
    // The component will handle the state update locally
  });

  return {
    triggerUpdateHomePhoto: mutation.mutate,
    updateHomePhotoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
